import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServicesHero() {
  const { t } = useTranslation();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-[70vh] overflow-hidden flex items-center">
      {/* Background with Parallax */}
      <div 
        className="absolute inset-0 w-full h-[130%]"
        style={{ 
          transform: `translateY(${scrollY * 0.35}px)`,
          willChange: 'transform'
        }}
      >
        <img
          src="https://public.readdy.ai/ai/img_res/1bfedcf9686187b4fb3c33e091e07d5d.jpg"
          alt="Atelier de réparation de bagages"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a2e]/95 via-[#1a1a2e]/85 to-[#1a1a2e]/70"></div>

      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-20 w-64 h-64 bg-[#FF6B6B]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-[#4ECDC4]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <i className="ri-service-fill text-[#FF6B6B]"></i>
            <span className="text-white/80 text-sm font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {t('servicesPage.heroBadge')}
            </span>
          </div>

          <h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t('servicesPage.heroTitle')}
            <br />
            <span className="bg-gradient-to-r from-[#FF6B6B] via-[#FF8E53] to-[#4ECDC4] bg-clip-text text-transparent">
              {t('servicesPage.heroTitleHighlight')}
            </span>
          </h1>

          <p className="text-xl text-white/70 mb-8 max-w-2xl leading-relaxed">
            {t('servicesPage.heroDesc')}
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="group px-8 py-4 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white rounded-2xl font-semibold hover:shadow-2xl hover:shadow-[#FF6B6B]/30 transition-all cursor-pointer whitespace-nowrap flex items-center gap-3"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t('servicesPage.heroCtaPrimary')}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
            <a
              href="tel:+3220000000"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-2xl font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap border border-white/20 flex items-center gap-3"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <i className="ri-phone-line"></i>
              {t('servicesPage.heroCtaSecondary')}
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 80L60 73.3C120 66.7 240 53.3 360 46.7C480 40 600 40 720 43.3C840 46.7 960 53.3 1080 56.7C1200 60 1320 60 1380 60L1440 60V80H1380C1320 80 1200 80 1080 80C960 80 840 80 720 80C600 80 480 80 360 80C240 80 120 80 60 80H0Z"
            fill="#F8FAFC"
          />
        </svg>
      </div>
    </section>
  );
}
